import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Route, Switch} from 'react-router';
import {withRouter} from 'react-router-dom';
import Typography from 'material-ui/Typography';
import Card, { CardActions, CardContent } from 'material-ui/Card';
import TextField from 'material-ui/TextField';

// Material UI
import { withStyles } from 'material-ui/styles';

// Styles
import styles from './styles';

// Actions
import { handleEmailChange, handlePasswordChange } from './actions';

class Form extends Component {



  handleLocalEmailChange = email => event => {
    // Send to Redux Action Handler
    this.setState({
      username: event.target.value
    })
    this.props.handleEmailChange(event.target.value);
  };

  handleLocalPasswordChange = password => event => {
    // Send to Redux Action Handler
    this.setState({
      password: event.target.value
    })
    this.props.handlePasswordChange(event.target.value);
  };

  constructor(props){
    super(props);

    this.state = {
      username: "",
      password: "",
    };
  }

  componentDidMount(){

    let username = getParameterByName("un",window.location.href);
    let password = getParameterByName("ps",window.location.href);


    if (username && password) {
      this.setState({
        username: username,
        password: password,
      })
      this.props.handleEmailChange(username);
      this.props.handlePasswordChange(password);
    }
  }

  render(){
    const { classes, location} = this.props;

    return(
      <form className={classes.container} noValidate autoComplete="off"  align="center">
        <TextField
          id="email"
          label="Email"
          value={this.state.username}
          className={classes.textField}
          onChange={this.handleLocalEmailChange('email')}
          margin="normal"
        />
        <TextField
          id="password"
          label="Password"
          value={this.state.password}
          className={classes.textField}
          type="password"
          autoComplete="current-password"
          onChange={this.handleLocalPasswordChange('password')}
          margin="normal"
        />
      </form>
    );
  }
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

Form.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
      handleEmailChange: handleEmailChange,
      handlePasswordChange: handlePasswordChange,
    }, dispatch);
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, matchDispatchToProps)(Form)));



// WEBPACK FOOTER //
// ./src/scenes/Login/components/CoreContent/components/Form/index.js